import spamBotProtection from '../shared/helpers/spam_bot_protection';

document.addEventListener('DOMContentLoaded', () => {
  spamBotProtection();
});
